"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Sort_1 = __importDefault(require("@material-ui/icons/Sort"));
var styles_1 = require("@material-ui/core/styles");
var index_1 = require("../../../../index");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        buttonRoot: {
            minWidth: 0,
            marginRight: spacing(),
            paddingLeft: spacing(),
            paddingRight: spacing()
        },
        buttonStartIcon: {
            marginRight: 0,
            marginLeft: 0
        }
    });
});
var SortingButton = function (props) {
    var onClick = props.onClick;
    var classes = useStyles();
    return (react_1.default.createElement(index_1.Button, { onClick: onClick, startIcon: react_1.default.createElement(Sort_1.default, null), classes: {
            root: classes.buttonRoot,
            startIcon: classes.buttonStartIcon
        } }));
};
exports.default = SortingButton;
